// extracted by mini-css-extract-plugin
export default {"wrapper":"ServiceList_wrapper__cs47M","pageHeader":"ServiceList_pageHeader__VApA-","intro":"ServiceList_intro__abYh1","sectionTitle":"ServiceList_sectionTitle__V7Vq4"};